import { render, staticRenderFns } from "./searchbar.vue?vue&type=template&id=b94a388a&lang=pug"
import script from "./searchbar.vue?vue&type=script&lang=js"
export * from "./searchbar.vue?vue&type=script&lang=js"
import style0 from "./searchbar.vue?vue&type=style&index=0&id=b94a388a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports